import React from 'react'
import OrderBookApproval from '../../../components/projectmng/obtainorder/OrderBookApproval'

const OrderBookApprovalContainer = ({ approvalList }) => {
    return <OrderBookApproval approvalList={approvalList} />
}

export default OrderBookApprovalContainer
